import React from 'react';
import {Link} from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import CustomerListFilter from '../customerList/CustomerListFilter';
import MenuPage from '../../pages/MenuPage';
import TimePickerDialog from "../dialog/TimePickerDialog";
import {LoomisColors} from '../../lib/LoomisColors';
import Pager from "../pagination/Pager";

const CustomerList = ({ paging, customers, openCustomer, onCreateCustomerClick, timepickDialog, syncCustomer, openTimePickerDialog, closeTimePickerDialog, cancelTimePickerDialog, fetchCustomers, searchKey }) => {

    const handleTimePickerDialogClose = (range) => {
        if(range){
            let startTime = moment(range.start).format("YYYY-MM-DD HH:mm:ss");
            let endTime = moment(range.end).format("YYYY-MM-DD HH:mm:ss");

            closeTimePickerDialog(range);

            // Call synchronize!!!
            syncCustomer(timepickDialog.id, {startTime, endTime});

        } else {
            cancelTimePickerDialog(range);
        }
    };


    const handleSyncYellow = (id) => {
        syncCustomer(id);
    }

    return (
        <MenuPage title="Customers" onBackClick={()=>{alert("Klick")}}>
            <div>
                <TimePickerDialog open={timepickDialog.open}
                                  start={timepickDialog.range.start}
                                  end={timepickDialog.range.end}
                                  handleClose={handleTimePickerDialogClose}/>
            </div>
            <div className="ButtonWrapper">
                <RaisedButton type="button" label="New Customer"
                              fullWidth={false}
                              onTouchTap={onCreateCustomerClick} />
            </div>

            <Grid fluid className="noXsPadding">
                <Row>
                    <Col xs={12}>
                        <CustomerListFilter fetchFilteredCustomers={fetchCustomers} searchKey={searchKey}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Table selectable={false} onCellClick={(rowNumber) => openCustomer(rowNumber)} >
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                                <TableRow>
                                    <TableHeaderColumn>ID</TableHeaderColumn>
                                    <TableHeaderColumn>Name</TableHeaderColumn>
                                    <TableHeaderColumn>Address 1</TableHeaderColumn>
                                    <TableHeaderColumn>Address 2</TableHeaderColumn>
                                    <TableHeaderColumn>Country</TableHeaderColumn>
                                    <TableHeaderColumn>Synchronisation</TableHeaderColumn>
                                    <TableHeaderColumn>Synchronization Error</TableHeaderColumn>

                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover={true}>
                                {customers.map(customer =>
                                    <TableRow key={customer.id}>
                                        <TableRowColumn>{customer.id}</TableRowColumn>
                                        <TableRowColumn>
                                            <Link to={`/customers/${customer.id}`}>{customer.name}</Link>
                                        </TableRowColumn>
                                        <TableRowColumn>{customer.adress1}</TableRowColumn>
                                        <TableRowColumn>{customer.adress2}</TableRowColumn>
                                        <TableRowColumn>{customer.countryName}</TableRowColumn>
                                        <TableRowColumn>
                                            { customer.sync_state === 'GREEN' ?
                                                <RaisedButton type="button"
                                                              label="Synchronize"
                                                              backgroundColor={LoomisColors.grey}
                                                              fullWidth={false}
                                                              onClick={(e) => {
                                                                  e.stopPropagation()
                                                                  openTimePickerDialog(customer.id)
                                                              }} />
                                                : customer.sync_state === 'YELLOW' ? <RaisedButton type="button"
                                                                                                 backgroundColor={LoomisColors.yellow}
                                                                                                 label="Synchronize"
                                                                                                 fullWidth={false}
                                                                                                 onClick={(e) => {
                                                                                                     e.stopPropagation()
                                                                                                     handleSyncYellow(customer.id)
                                                                                                 }} />
                                                    : customer.syncState === 'RED' ? <RaisedButton type="button"
                                                                                                 backgroundColor={LoomisColors.red}
                                                                                                 label="Sync disabled"
                                                                                                 fullWidth={false}
                                                        />
                                                        : ""
                                            }
                                        </TableRowColumn>
                                        <TableRowColumn>{customer.sync_errorText}</TableRowColumn>
                                    </TableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Pager currentPage={paging.number} totalPages={paging.totalPages} fetchUsers={fetchCustomers} searchKey={searchKey} />
                </Row>

            </Grid>
        </MenuPage>
    )
}

export default CustomerList;


// WEBPACK FOOTER //
// ./src/components/customerList/CustomerList.js